module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"paymentReceived":"Pagamento ricevuto, appuntamento del {date} è confermato!"}}')
  delete Component.options._Ctor
}
